module.exports = __webpack_public_path__ + "bv-vibe-grad.d2439339838502c4ad3c8864b896ecb8.svg";